import { Subject } from 'rxjs';

const subject = new Subject();

export const MenuService = {
    sendAtivo: (ativo: boolean) => subject.next(ativo),
    getAtivo: () => subject.asObservable()
};